import ChatViewHandler from '@components/chat/views/ChatViewHandler'
import { useCallback, useEffect } from 'react'
import { useChatOpenState, useSetChatUnreadMessages } from '@components/chat/context/ChatStateContext'
import { post } from '@api/apiFetcher'

import withUser from '@hoc/withUser'

const API_CHECK_FOR_INCOMING_MESSAGES = '/api/chat/check_for_incoming_messages'
const CHECK_EVERY = 60000

let interval
const ChatComponent = ({ user, isLoggedIn }) => {
    const isOpen = useChatOpenState()
    const setUnreadMessages = useSetChatUnreadMessages()

    const checkForUnreadMessages = useCallback(() => {
      post({
        path: API_CHECK_FOR_INCOMING_MESSAGES,
        auth: user?.token,
      })
      .then(res => {
        if (res.success) setUnreadMessages(res.unread)
      })
    }, [user?._id])

    useEffect(() => {
      if (isLoggedIn) checkForUnreadMessages()
    }, [user?._id])

    useEffect(() => {
      if (isLoggedIn) {
        interval = setInterval(checkForUnreadMessages, CHECK_EVERY)

      } else {
        clearInterval(interval)
      }

      return () => clearInterval(interval)
    }, [isLoggedIn])

    return isLoggedIn
        ? <ChatViewHandler user={user} isOpen={isOpen} />
        : null
}

export default withUser(ChatComponent)